import React from 'react';
import { Navigate, NavLink, Outlet, Route, Routes } from 'react-router-dom';
import { Activity, Archive, BarChart3 } from 'lucide-react';
import Dashboard from './pages/Dashboard';
import History from './pages/History';
import SavedVideos from './pages/SavedVideos';
import Analytics from './pages/Analytics';
import Landing from './pages/Landing';
import ReportMenu from './components/ReportMenu';

function NavItem({ to, label, icon: Icon }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `nav-item ${isActive ? 'nav-item--active' : ''}`
      }
      end={to === '/'}
    >
      <Icon size={14} />
      <span>{label}</span>
    </NavLink>
  );
}

function ProtectedShell() {
  return (
    <div className="app-shell">
      <header className="top-header">
        <div className="brand">
          <div className="brand__badge">
            <img src="/logo-dashboard.svg" alt="" />
          </div>
          <div>
            <h1>FSQA AI Monitor</h1>
            <p>AI based Food Safety and Quality Assurance detection system</p>
          </div>
        </div>
        <nav className="top-nav">
          <NavItem to="/" label="Live Dashboard" icon={Activity} />
          <NavItem to="/analytics" label="Analytics" icon={BarChart3} />
          <NavItem to="/history" label="History" icon={Archive} />
          <ReportMenu />
        </nav>
      </header>

      <main className="main-view">
        <Outlet />
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/welcome" element={<Landing />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<ProtectedShell />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/history" element={<History />} />
        <Route path="/history/saved-videos" element={<SavedVideos />} />
      </Route>
    </Routes>
  );
}

